import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { CommonGNB } from "@bookips/solvook-ui-library";
import { SearchRequestForm } from "../../../containers/Header/SearchRequestForm";
const SkeletonGNB = ()=>{
    return /*#__PURE__*/ _jsx(CommonGNB, {
        isLoggedIn: true,
        onClickLogo: ()=>mixpanelEvent("Logo Clicked"),
        searchTextField: /*#__PURE__*/ _jsx(SearchRequestForm, {}),
        menu: {},
        disabledCategory: true
    });
};
export default SkeletonGNB;
